import React, { useState, useEffect } from 'react';
import { PUBLIC_IMG_URL } from '/src/utilities/endpoints';
import { REPORT_TYPES } from '/src/utilities/constants';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ContentImage = (props) => {

    const { data, socialTitle, type } = props;
    const { preview_image_data, image_data } = data;
    const [imagePath, setImagePath] = useState(null);
    const [imageType, setImageType] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    /*
     * Image Types
     * 'preview_image_data' - long image size used on desktop
     * 'image_data' - squarish image size used on mobile or when desktop img not available
     */
    useEffect(() => {
        let isDesktop = (typeof window !== 'undefined' && window.innerWidth > 600);
        if (isDesktop) {
            setImageType("long");
            if (preview_image_data && preview_image_data.path) {
                setImagePath(preview_image_data.path);
            } else {
                getPlaceholderImage();
            }
        } else if (image_data && image_data.path) {
            setImageType("square");
            setImagePath(image_data.path);
        }
    }, []);


    useEffect(() => {
        if (imagePath) {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = imagePath;
            document.head.appendChild(link);
        }
    }, [imagePath]);

    // alternate between red & black placeholder image
    const getPlaceholderImage = () => {
        const isEvenNumber = (data.id % 2 == 0);
        const bgImageColor = (isEvenNumber ? 'black' : 'red')

        if (type === "research") {
            if (data.type_id == REPORT_TYPES.paid) {
                setImagePath(`${PUBLIC_IMG_URL}/default-news-images/research_${bgImageColor}_paid.png`);
            } else if (data.type_id === REPORT_TYPES.free || data.type_id === REPORT_TYPES.sponsored) {
                setImagePath(`${PUBLIC_IMG_URL}/default-news-images/research_${bgImageColor}_free.png`);
            } else {
                // handle report with invalid price
                setImagePath(`${PUBLIC_IMG_URL}/default-news-images/news_${bgImageColor}.webp`);
            }
        } else if (type === "news") {
            setImagePath(`${PUBLIC_IMG_URL}/default-news-images/news_${bgImageColor}.webp`);
        }
    }

    return (
        <div className='content-main-img'>
            {!imageLoaded && (
                <Skeleton
                    width="100%"
                    height="100%"
                    style={{ position: 'absolute'}}
                />
            )}

            <img
                src={imagePath}
                alt={socialTitle}
                title={socialTitle}
                key={socialTitle}
                data-img-size={imageType}
                className="img-fluid"
                loading='eager'
                onLoad={() => setImageLoaded(true)}
                onError={() => getPlaceholderImage()}
            />
        </div>
    )

}

export default ContentImage;
